import { useRef } from 'react';
import utils from '@/common/utils';

export default function useBabelTowerDevBranch(url, keepQuery = false) {
  const branchNameInUrl = useRef(url);
  if (process.env.NODE_ENV === 'development' || process.env.API_ENV === 'beta') {
    const branchName = utils.getQuery('_babelBranch');
    if (!branchName) return branchNameInUrl.current;
    if (branchNameInUrl.current.indexOf(branchName) !== -1) return branchNameInUrl.current;
    const index = branchNameInUrl.current.indexOf('index.html');
    branchNameInUrl.current = branchNameInUrl.current.slice(0, index) + branchName + '/index.html';
    if (keepQuery) {
      branchNameInUrl.current = branchNameInUrl.current + url.slice(index + 'index.html'.length);
    }
    // window.location.pathname.indexOf()
    // https://betah5.m.jd.com/active/babelTower/ljc/demo/index.html#/editorDemo?
  }

  return branchNameInUrl.current;
}
